import * as React from "react";

import { cn } from "src/lib/utils";

type InputSize = "default" | "lg";

const SIZE: Record<InputSize, string> = {
	default: "h-9",
	lg: "h-11"
};

interface InputProps extends Omit<React.ComponentProps<"input">, "size"> {
	/** `default` = h-9 (compact/pill); `lg` = h-11 (text field, per benchmark). */
	inputSize?: InputSize;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, inputSize = "default", ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					// White background so inputs read clearly inside subtle-toned
					// section cards; control border per the design benchmark.
					// Callers can override to `bg-transparent` when they want the
					// input to inherit the surrounding surface colour.
					"flex w-full rounded-lg border border-input bg-background px-3 py-1 text-base shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:bg-zinc-100 disabled:text-zinc-600",
					SIZE[inputSize],
					className
				)}
				ref={ref}
				{...props}
			/>
		);
	}
);
Input.displayName = "Input";

export { Input };
